import {
  EConfiguratorFileGroup,
  EConfiguratorQuestionType,
  IConfiguratorQuestion,
  IConfiguratorSection
} from '../models/configurator.model';
import { countPhotoStepFiles, PHOTO_STEP_FILE_GROUPS } from './configurator-files.config';

const T = 'ProjectConfiguratorV2.Questions';

/** Step 5 "Fotos & Dokumentation": four upload groups, all optional. */
export const PHOTOS_STEP_SECTIONS: IConfiguratorSection[] = [
  {
    id: 'files',
    questions: [
      {
        id: 'fileCounts',
        type: EConfiguratorQuestionType.FILES,
        help: `${T}.files.help`,
        summaryLabel: `${T}.files.summary`,
        fileGroups: PHOTO_STEP_FILE_GROUPS,
        answered: (_, answers) => countPhotoStepFiles(answers) > 0,
        summaryValue: (_, context) =>
          context.translate('ProjectConfiguratorV2.Summary.files', {
            count: countPhotoStepFiles(context.answers)
          })
      }
    ]
  }
];

/** Images that inspire the customer, in the inspiration section of step 4. */
export const INSPIRATION_FILES_QUESTION: IConfiguratorQuestion = {
  id: `fileCounts.${EConfiguratorFileGroup.INSPIRATION}`,
  type: EConfiguratorQuestionType.FILES,
  label: `${T}.inspirationFiles.label`,
  help: `${T}.inspirationFiles.help`,
  summaryLabel: `${T}.inspirationFiles.summary`,
  fileGroups: [EConfiguratorFileGroup.INSPIRATION],
  summaryValue: (value, context) =>
    context.translate('ProjectConfiguratorV2.Summary.images', { count: value })
};
